<template>
  <div class="ehc-interview-toolbar">
    <div v-if="pageNo > 0" class="ehc-interview-toolbar__progress mb-3">
      <div class="text-caption text--secondary mb-1">
        Step {{ pageNo }} of {{ Math.max(fieldsLength - 1, 1) }}
      </div>
      <v-progress-linear
        :value="progressPercent"
        color="primary"
        height="6"
        rounded
      ></v-progress-linear>
    </div>

    <v-row class="mt-0" align="center" justify="center">
      <v-col v-if="!pageNo" key="toolbar-start" cols="12" class="text-center">
        <ehc-btn
          v-if="setupTrainingVideoUrl"
          key="btn-setup-training"
          outlined
          :dark="false"
          block
          class="mb-3"
          @click="openSetupTraining"
        >
          <v-icon left small>mdi-play-circle</v-icon>
          <span class="notranslate" translate="no">Watch how this setup works</span>
        </ehc-btn>
        <ehc-btn
          key="btn-get-started"
          color="primary"
          dark
          large
          @click="nextInterview(formData.propertyId)"
        >
          <span class="notranslate" translate="no">Get started</span>
        </ehc-btn>
      </v-col>
      <v-col
        v-if="pageNo && !isFinishPage"
        key="toolbar-back"
        cols="5"
        class="text-center"
      >
        <ehc-btn
          key="btn-back"
          outlined
          :dark="false"
          @click="backInterview(formData.propertyId)"
        >
          <span class="notranslate" translate="no">Back</span>
        </ehc-btn>
      </v-col>
      <v-col
        v-if="pageNo && !isFinishPage"
        key="toolbar-next"
        cols="5"
        class="text-center"
      >
        <ehc-btn
          :key="'btn-next-' + continueLabel"
          color="primary"
          dark
          @click="nextInterview(formData.propertyId)"
        >
          <span class="notranslate" translate="no">{{ continueLabel }}</span>
        </ehc-btn>
      </v-col>
      <v-col
        v-if="isFinishPage"
        key="toolbar-finish-back"
        cols="12"
        class="text-center"
      >
        <ehc-btn
          key="btn-finish-back"
          outlined
          :dark="false"
          class="mr-2 mb-2"
          @click="backInterview(formData.propertyId)"
        >
          <span class="notranslate" translate="no">Back</span>
        </ehc-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "EhcInterviewToolbarBottom",
  props: {
    pageNo: {
      type: Number,
      default: 0,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    fieldsLength: {
      type: Number,
      default: 0,
    },
    setupTrainingVideoUrl: {
      type: String,
      default: "",
    },
  },
  computed: {
    isFinishPage() {
      return this.pageNo === this.fieldsLength - 1;
    },
    progressPercent() {
      const steps = Math.max(this.fieldsLength - 1, 1);
      return Math.min(100, Math.round((this.pageNo / steps) * 100));
    },
    continueLabel() {
      if (this.pageNo === this.fieldsLength - 2) {
        return "Finish";
      }
      return "Next";
    },
  },
  methods: {
    nextInterview(propertyId) {
      this.$emit("nextInterview", propertyId);
    },
    backInterview(propertyId) {
      this.$emit("backInterview", propertyId);
    },
    openSetupTraining() {
      this.$emit("openSetupTraining");
    },
  },
};
</script>

<style scoped>
.ehc-interview-toolbar__progress {
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}
</style>
